<div class="search-mode" *ngIf="!collapseSearch">
  <div class="search-container-overlay" *ngIf="useTwoColumns && selectedButtonType === searchType.ADVANCED"></div>
  <avano-panel [headerText]="headerText" [class.advanced-two-column]="useTwoColumns && selectedButtonType === searchType.ADVANCED" [noPadding]="true">
    <ng-template avanoTemplate="areaactions">
      <i class="icon-container-collapse icon-content-chevron-left" (click)="toggleCollapseState()"></i>
    </ng-template>
    <div class="search-content">
      <div class="search-toggle-button">
        <avano-search-toggle
          [advancedLabel]="'search.service.advanced' | translate"
          [quickLabel]="'search.service.quick' | translate"
          [(ngModel)]="selectedButtonType"
        ></avano-search-toggle>
      </div>
      <scip-multi-input *ngIf="selectedButtonType === searchType.QUICK" [multiInputConfiguration]="quickSearchConfiguration"></scip-multi-input>
      <scip-multi-input
        *ngIf="selectedButtonType === searchType.ADVANCED"
        [multiInputConfiguration]="advancedSearchConfiguration"
        (selectionChanged)="filterSelectionChanged.emit($event)"
      ></scip-multi-input>
    </div>
    <scip-recent-searches *ngIf="selectedButtonType === searchType.QUICK" [recentSearchesType]="recentSearchType"></scip-recent-searches>
  </avano-panel>
</div>
<div *ngIf="collapseSearch" class="collapsed-mode" (click)="toggleCollapseState()">
  <i class="icon-content-search"></i>
</div>
